import { API_URL, authFetch } from '../components/utils/auth';

async function readJson(response, fallback) {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.detail || fallback);
  return data;
}

export async function fetchApprovals(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value) search.set(key, value);
  });
  const response = await authFetch(`${API_URL}/staff/approvals/${search.toString() ? `?${search}` : ''}`);
  return readJson(response, 'Unable to load approvals.');
}

export async function fetchApproval(id) {
  const response = await authFetch(`${API_URL}/staff/approvals/${id}/`);
  return readJson(response, 'Unable to load approval.');
}

export async function approveRequest(id, note = '') {
  const response = await authFetch(`${API_URL}/staff/approvals/${id}/approve/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ note }),
  });
  return readJson(response, 'Unable to approve request.');
}

export async function declineRequest(id, reason = '') {
  const response = await authFetch(`${API_URL}/staff/approvals/${id}/decline/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ reason }),
  });
  return readJson(response, 'Unable to decline request.');
}

export async function requestMoreInfo(id, message = '') {
  const response = await authFetch(`${API_URL}/staff/approvals/${id}/request-info/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ message }),
  });
  return readJson(response, 'Unable to request more information.');
}

export async function respondToInfoRequest(id, message = '') {
  const response = await authFetch(`${API_URL}/staff/approvals/${id}/respond/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ message }),
  });
  return readJson(response, 'Unable to send response.');
}

export async function assignApproval(id, assigneeId) {
  const response = await authFetch(`${API_URL}/staff/approvals/${id}/assign/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ assignee_id: assigneeId }),
  });
  return readJson(response, 'Unable to assign request.');
}

export async function updateFulfillment(id, status, note = '') {
  const response = await authFetch(`${API_URL}/staff/approvals/${id}/fulfillment/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ status, note }),
  });
  return readJson(response, 'Unable to update fulfillment.');
}

export async function createTeamRequest(payload) {
  const response = await authFetch(`${API_URL}/staff/team-requests/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return readJson(response, 'Unable to create team request.');
}